<template>
  <div>
    <a v-if="iconUrl" :href="url">
      <img :src="iconUrl" class="app-banner" />
    </a>
    <a v-if="!iconUrl" :href="url">
      {{ name }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['name', 'url'],
  data() {
    return {
      iconSrc: ''
    };
  },
  computed: {
    iconUrl() {
      switch (this.name) {
        case 'PolicyConnect':
          return '/public/PolicyConnect.png';
        case 'SafeTripBuilder':
          return '/public/StbHorizontalLogo.png';
        case 'CompliCare':
          return '/public/CompliCare.png';
        case 'CompliSpace Primary':
          return '/public/CompliSpacePrimary.png';
        default:
          return '';
      }
    }
  }
};
</script>

<style scoped>
.app-banner {
  max-width: 15rem;
  background: white;
  border-radius: 0.3rem;
  padding: 0.3rem;
}
</style>
